import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardComponent } from './card/card.component';
import { SkeletonCommonModule } from '../../common/components/common.module';
import { CardAvatarComponent } from './card-avatar/card-avatar.component';
import { CardRandomInfoComponent } from './card-random-info/card-random-info.component';
import { CardMetaComponent } from './card-meta/card-meta.component';

@NgModule({
  declarations: [CardComponent, CardAvatarComponent, CardRandomInfoComponent, CardMetaComponent],
  imports: [CommonModule, SkeletonCommonModule],
  exports: [CardComponent]
})
export class CardModule {}
